import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=2b35da8d&scoped=true"
import script from "./InviteForm.vue?vue&type=script&lang=ts"
export * from "./InviteForm.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InviteForm.vue?vue&type=style&index=1&id=2b35da8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35da8d",
  null
  
)

export default component.exports